import { useState, useCallback } from 'react';
import type { TagFormData } from './Context';
import { TagFormContext } from './Context';
import { Tags } from './interfaces';

type Props = {
  defaultState?: TagFormData;
} & ChildrenProps;

const DefaultState: TagFormData = {
  title: '',
  parentId: null,
  category: null,
  includeSummary: true,
  color: Tags.defaultColor,
};

export const TagFormContainer = ({ children, defaultState = DefaultState }: Props) => {
  const [state, setState] = useState<TagFormData>(defaultState);

  const updateState = useCallback((data: Partial<TagFormData>) => {
    setState(old => ({ ...old, ...data }));
  }, [setState]);

  return (
    <TagFormContext.Provider value={{ data: state, dispatch: updateState }}>
      {children}
    </TagFormContext.Provider>
  );
};